import HighlightQuote from "./HighlightQuote";

export default HighlightQuote;